import { render, staticRenderFns } from "./plataccount-payfee-list.vue?vue&type=template&id=203b64dc&scoped=true&"
import script from "./plataccount-payfee-list.vue?vue&type=script&lang=js&"
export * from "./plataccount-payfee-list.vue?vue&type=script&lang=js&"
import style0 from "./plataccount-payfee-list.vue?vue&type=style&index=0&id=203b64dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b64dc",
  null
  
)

export default component.exports